import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Form, Button, Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../actions/userActions";
import Loader from "../components/Loader";
import Message from "../components/Message";
import FormContainer from "../components/FormContainer";

function LoginScreen({ location, history }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const redirect = location.search ? location.search.split("=")[1] : "/";
  const userLogin = useSelector((state) => state.userLogin);
  const { error, loading, userInfo } = userLogin;

  useEffect(() => {
    if (userInfo) {
      history.push(redirect);
    }
  }, [history, userInfo, redirect]);

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(login(email, password));
  };

  return (
    <FormContainer>
      <h6 style={{ textAlign: "center" }}>My SneakerLab Account</h6>
      <Container>
        <Row>
          <Col></Col>
          <Col xs={8}>
            <h1 style={{ marginLeft: "1rem" }}>
              <strong>Sign In</strong>
            </h1>
          </Col>
        </Row>
      </Container>
      {error && <Message variant="danger">{error}</Message>}
      {loading && <Loader />}
      <Form onSubmit={submitHandler}>
        <Form.Group controlId="email">
          <Form.Label>
            <h5>Email Address</h5>
          </Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          ></Form.Control>
        </Form.Group>
        <Form.Group controlId="password" className="py-3">
          <Form.Label>
            <h5>Password</h5>
          </Form.Label>
          <Form.Control
            type="password"
            placeholder="Enter Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          ></Form.Control>
        </Form.Group>
        <Button type="submit" variant="primary">
          <h6>Sign In</h6>
        </Button>
      </Form>
      <Row className="py-3">
        <Col>
          <strong>New Customer?</strong>
          <Link to={redirect ? `/register?redirect=${redirect}` : "/register"}>
            <i>Register</i>
          </Link>
        </Col>
      </Row>
    </FormContainer>
  );
}

export default LoginScreen;
